export class Operator {
  id: number;
  name: string;
  operatorOrganisationId: number;
  isEligibleForOrderCreation: boolean;
}

// CtlSweden
export const VY_X_TAGET = 1285;
export const VY_NORRTAG = 1120;
export const VY_NORGE = 1283;
export const VY_VARMLANDSTRAFIK = 1284;
export const SL_TUNNELBANAN_MTR = 1126;
export const VR_SNABBTAG = 1288;
export const SKANETRAFIKEN = 1450;
export const ORESUNDSTAG_TRANSDEV = 1726;
export const SL_PENDELTAGEN_SJ_STOCKHOLMSSTAG = 1806;
export const STEGRA = 1834;
export const VASTTRAFIK = 1848;
export const VY = 1862;
export const SL_SALTSJOBANAN_NV = 1900;
export const SL_TVARBANAN_HBS = 1901;
export const HEDE_FASHION_OUTLET = 2000;
export const NORRTAG_VR = 2001;
export const SL_TUNNELBANAN_CS = 2002;
export const ORESUNDSTAG = 2003;
export const PAGATAGEN = 2004;
export const VR_MALARTAG = 2007;
export const BALTIC_GATEWAY = 2008;
export const LYNRA_SHUTTLE_SERVICE = 2009;
export const SNALLTAGET = 2010;
export const SJ = 2011;
export const SJ_VANERTAG = 2012;

// CtlNorway
export const GO_AHEAD_NORDIC = 1317;
export const SJ_NORD = 1394;
export const FLYTOGET = 2005;

// CtlFinland
export const VR_FINLAND = 1813;
export const TORNION_JUNABUSSI = 2006;

// CtlDenmark
export const METRO_KOBENHAVN = 1814;

// NoCtl
export const EVENT = 1756;
export const TESTTRAFIKOPERATOR = 1684;

// CtlSweden
export const CtlSwedenOperatorIds = [
  VY_X_TAGET,
  VY_NORRTAG,
  VY_NORGE,
  VY_VARMLANDSTRAFIK,
  SL_TUNNELBANAN_MTR,
  VR_SNABBTAG,
  SKANETRAFIKEN,
  ORESUNDSTAG_TRANSDEV,
  SL_PENDELTAGEN_SJ_STOCKHOLMSSTAG,
  STEGRA,
  VASTTRAFIK,
  VY,
  SL_TVARBANAN_HBS,
  SL_SALTSJOBANAN_NV,
  HEDE_FASHION_OUTLET,
  NORRTAG_VR,
  SL_TUNNELBANAN_CS,
  ORESUNDSTAG,
  PAGATAGEN,
  VR_MALARTAG,
  BALTIC_GATEWAY,
  LYNRA_SHUTTLE_SERVICE,
  SNALLTAGET,
  SJ,
  SJ_VANERTAG,
];

// CtlNorway
export const CtlNorwayOperatorIds = [GO_AHEAD_NORDIC, SJ_NORD, FLYTOGET];

// CtlFinland
export const CtlFinlandOperatorIds = [VR_FINLAND, TORNION_JUNABUSSI];

// CtlDenmark
export const CtlDenmarkOperatorIds = [METRO_KOBENHAVN];

// NoCtl
export const NoCtlOperatorIds = [TESTTRAFIKOPERATOR, EVENT];

// Country-based NoCtl (used by order-confirmation)
export const CtlCountryBasedNoneOperatorIds = [...NoCtlOperatorIds];

// Legacy department grouping kept for compatibility (used outside order-confirmation)
export const CtlNorgeOperatorIds = [1317, 1394];
export const CtlSydOperatorIds = [1726, 1450];
export const CtlMittOperatorIds = [1288, 1806, 1124, 1834];
export const CtlVastOperatorIds = [1120, 1284, 1848, 1283, 1285];
export const CtlNoneOperatorIds = [1814, 1813, 1756, 1684];
